import { useMemo } from 'react'

import { clsx } from 'clsx'

import type {
  Event,
  ExternalSearchResult,
  Member,
  Post,
  Space,
} from '@tribeplatform/gql-client/types'

import { HtmlContent } from '../../../../HtmlContent/HtmlContent.js'
import {
  ExtendedSmartSearchEntity,
  ExtendedSmartSearchEntityType,
} from '../../../SmartSearch.types.js'
import { HistoryItem } from '../../SearchHistory/SearchHistory.types.js'

interface Props {
  item: ExtendedSmartSearchEntity
  entityType: ExtendedSmartSearchEntityType
}

export const SearchEntityRowContent = ({ item, entityType }: Props) => {
  const title =
    entityType === ExtendedSmartSearchEntityType.HISTORY
      ? (item as HistoryItem).data.title
      : ((item as Post).title ?? (item as Member | Space).name)

  const description = useMemo(() => {
    if (entityType === ExtendedSmartSearchEntityType.EVENTS) {
      const { shortContent, attachments, embeds, mentions } = item as Event
      return shortContent ? (
        <HtmlContent
          className="text-sm line-clamp-1"
          value={shortContent}
          attachments={attachments}
          embeds={embeds}
          mentions={mentions}
        />
      ) : null
    }
    if (entityType === ExtendedSmartSearchEntityType.HISTORY) {
      return (item as HistoryItem).data.description
    }
    return (item as Post | ExternalSearchResult)?.description
  }, [item, entityType])

  const hasDescription = !!description

  return (
    <div className="grid gap-1 h-full sm:grid-rows-2 sm:items-center">
      <h2
        className={clsx('font-semibold line-clamp-1', {
          'row-span-2': !hasDescription,
        })}
      >
        {title}
      </h2>
      {hasDescription && (
        <span className="text-sm line-clamp-1">{description}</span>
      )}
    </div>
  )
}
